import axios from 'axios';
import { QueryClient } from '@tanstack/react-query';
import { AuthClient } from '../auth/AuthClient';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 10000, retry: 1 },
    },
});
export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL ?? '',
});
apiClient.interceptors.request.use((config) => {
    const token = AuthClient.getAccessToken();
    if (token)
        config.headers.Authorization = `Bearer ${token}`;
    return config;
});
apiClient.interceptors.response.use((res) => res, async (err) => {
    const originalRequest = err.config;
    if (err.response?.status === 401 && originalRequest && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
            await AuthClient.refreshToken();
            const token = AuthClient.getAccessToken();
            if (token)
                originalRequest.headers.Authorization = `Bearer ${token}`;
            return apiClient(originalRequest);
        }
        catch {
            AuthClient.logout();
            return Promise.reject(err);
        }
    }
    if (err.response?.status === 401) {
        AuthClient.logout();
    }
    return Promise.reject(err);
});
